import app from '~/store/app';

export function useApp() {
  return app;
}
